import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef20d358"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "main-table" }
const _hoisted_3 = { class: "list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode()
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("提 交")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")

import { ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";
import type { ElForm } from "element-plus";
import { addExams, getExamInfo } from "@/api/backstage";
import { reactive, ref, onMounted } from "vue";
import SelectBox from "./components/select.vue"; // 选题

type FormInstance = InstanceType<typeof ElForm>;


export default /*#__PURE__*/_defineComponent({
  __name: 'examTestDetails',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const ruleFormRef = ref<FormInstance>();
const multipleSelection: any = ref([]);

const dialogVisible = ref(false);

const datas: any = reactive({
  preview: "",
  konwles: "",
  tableData: [],
  total: 0,
  subject: [],
  type: {
    QUESTION_ONE: {
      enumName: "单选",
      enumKey: "QUESTION_ONE",
    },
    QUESTION_MORE: {
      enumName: "多选",
      enumKey: "QUESTION_MORE",
    },
    QUESTION_SHORT: {
      enumName: "简答",
      enumKey: "QUESTION_SHORT",
    },
    QUESTION_NUM: {
      enumName: "打分",
      enumKey: "QUESTION_NUM",
    },
  },
  ruleForm: {
    questions: [],
    description: "",
    title: "",
  },
});
const rules = {
  title: [{ required: true, message: "请输入问卷名", trigger: "blur" }],
  questions: [{ required: true, message: "请选择题目", trigger: "blur" }],
};
let num: any = reactive(0);

const getInfo = async () => {
  // console.log(route.query);

  const res = await getExamInfo({
    id: route.query.id,
    examUserId: localStorage.getItem("examUserId"),
  });
  datas.ruleForm = res.data;
  multipleSelection.value = res.data.questions.map((item: any) => {
    return {
      ...item,
      checked: item.mustStatus == "1" ? true : false,
      statIdx: item.statIdx == "1" ? true : false,
    };
  });
  res.data.questions.forEach((item: any) => {
    if (item.statIdx == 1) {
      num++;
    }
  });
};

//提交
const putDatas = () => {
  // console.log(multipleSelection);
  datas.ruleForm.questions = multipleSelection.value.map((item: any) => {
    return {
      questionId: item.id,
      mustStatus: item.checked ? 1 : 0,
      statIdx: item.statIdx ? 1 : -1,
    };
  });

  if (route.query.id && route.query.type == "bianji") {
    datas.ruleForm.id = route.query.id;
  } else {
    datas.ruleForm.id = "";
  }
  addExams(datas.ruleForm).then((res: any) => {
    if (res.code === 200) {
      ElMessage({
        message: "操作成功",
        type: "success",
      });
      router.go(-1);
    } else {
      ElMessage({
        message: res.msg,
        type: "error",
      });
    }
  });
};

const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      putDatas();
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

//添加问题
const add = () => {
  dialogVisible.value = true;
};

//选择该题目是否为需要必填
const onChange = (e: any, idx: any) => {
  multipleSelection.value[idx].checked = e;
};

//选择该题目是否为需要统计
const onChange1 = (e: any, idx: any) => {
  if (e && num <= 6) {
    num++;
    multipleSelection.value[idx].statIdx = e;
    console.log(num);
  } else if (!e && num != 7) {
    num--;
    console.log(num);
  } else if (!e && num == 7) {
    num = 5;
    console.log(num);
  }

  if (num > 6) {
    multipleSelection.value[idx].statIdx = false;
    ElMessage({
      message: "最多只能选6个进行统计",
      type: "success",
    });
  }
};

const reduce = (item: any, i: any) => {
  if (item.statIdx && num != 7) {
    num--;
  } else if (item.statIdx && num == 7) {
    num = 5;
  }

  console.log(num);

  multipleSelection.value.splice(i, 1);
};

const close = async (val: any) => {
  // console.log(val);

  datas.ruleForm.questions = val;
  multipleSelection.value = val;

  if (route.query.id) {
    const res = await getExamInfo({
      id: route.query.id,
      examUserId: localStorage.getItem("examUserId"),
    });
    datas.ruleForm = res.data;
    multipleSelection.value.forEach((it) => {
      res.data.questions.forEach((item: any) => {
        if (item.id == it.id && item.statIdx == 1) {
          it.statIdx = true;
        }
        if (item.id == it.id && item.mustStatus == 1) {
          it.checked = true;
        }
      });
    });
    dialogVisible.value = false;
  } else {
    multipleSelection.value = val.map((item: any) => {
      return {
        ...item,
        checked: false,
      };
    });
    dialogVisible.value = false;
  }

  // res.data.questions.forEach((item: any) => {
  //   if (item.statIdx == 1) {
  //     num++;
  //   }
  // });
};
const close1 = (val: any) => {
  dialogVisible.value = false;
};
onMounted(() => {
  if (route.query.id) getInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_scrollbar, { ref: "scrollbarRef" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: datas.ruleForm,
            rules: rules,
            "label-width": "120px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "问卷名称",
                prop: "title"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    maxlength: "50",
                    modelValue: datas.ruleForm.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((datas.ruleForm.title) = $event)),
                    placeholder: "请输入"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "描述",
                prop: "description"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    maxlength: "150",
                    type: "textarea",
                    modelValue: datas.ruleForm.description,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((datas.ruleForm.description) = $event)),
                    placeholder: "请输入",
                    rows: "4"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "问题",
                prop: "questions"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("i", {
                    class: "iconfont icon-zengjia",
                    onClick: add
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(multipleSelection.value, (item, index) => {
              return (_openBlock(), _createElementBlock("li", { key: index }, [
                _createVNode(_component_el_tooltip, {
                  content: "删除",
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: "iconfont icon-jianshao",
                      onClick: ($event: any) => (reduce(item, index))
                    }, null, 8, _hoisted_4)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_el_tag, {
                  class: "ml-2",
                  type: "info"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(datas.type[item.type]?.enumName), 1)
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("span", null, _toDisplayString(index + 1) + "、", 1),
                _hoisted_5,
                _createElementVNode("span", {
                  innerHTML: item.title
                }, null, 8, _hoisted_6),
                _createVNode(_component_el_checkbox, {
                  modelValue: item.checked,
                  "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
                  label: "是否必填",
                  size: "large",
                  onChange: (e) => onChange(e, index)
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
                (
                datas.type[item.type]?.enumKey == 'QUESTION_ONE' ||
                datas.type[item.type]?.enumKey == 'QUESTION_NUM' ||
                datas.type[item.type]?.enumKey == 'QUESTION_MORE'
              )
                  ? (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: 0,
                      modelValue: item.statIdx,
                      "onUpdate:modelValue": ($event: any) => ((item.statIdx) = $event),
                      label: "是否进行统计分析",
                      size: "large",
                      onChange: (e) => onChange1(e, index)
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (submitForm(ruleFormRef.value))),
            style: {"margin":"40px 10px","padding":"0 20px"}
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).go(-1)))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 512),
    (dialogVisible.value)
      ? (_openBlock(), _createBlock(SelectBox, {
          key: 0,
          row: multipleSelection.value,
          onClose: close,
          onClose1: close1
        }, null, 8, ["row"]))
      : _createCommentVNode("", true)
  ]))
}
}

})